import { computed } from 'vue';
import { useRemoteConfigStore } from '../stores/remoteConfig.store';

/**
 * Kill-switch del selector de redes stablecoin del cotizador (BSI-63).
 * Gobierna únicamente el selector de red y su fee por red en `TransactionQuoter`:
 * apagado, el cotizador se comporta exactamente igual que antes del feature.
 * Es independiente de `feature_wallet_stablecoins` (redes dinámicas en
 * contactos) para permitir rollback aislado.
 */
export function useQuoterStablecoinNetworks() {
  const remoteConfigStore = useRemoteConfigStore();
  const config = remoteConfigStore.getFeatureFlag('feature_quoter_stablecoin_networks');

  const isEnabled = computed<boolean>(() => config.value.enabled);

  return { isEnabled };
}
